export const cookieList = {
   necessary: [
      {
         cookieName: "cookieyes-consent",
         duration: "1 year",
         description:
            "CookieYes sets this cookie to remember users’ consent preferences so that their preferences are respected on subsequent visits to this site. It does not collect or store any personal information about the site visitors.",
      },
      {
         cookieName: "__hssrc",
         duration: "session",
         description:
            "This cookie is set by Hubspot whenever it changes the session cookie. The __hssrc cookie set to 1 indicates that the user has restarted the browser, and if the cookie does not exist, it is assumed to be a new session.",
      },
      {
         cookieName: "__hssc",
         duration: "30 minutes",
         description:
            "HubSpot sets this cookie to keep track of sessions and to determine if HubSpot should increment the session number and timestamps in the __hstc cookie.",
      },
   ],
   functional: [
      {
         cookieName: "_hjAbsoluteSessionInProgress",
         duration: "30 minutes",
         description:
            "Hotjar sets this cookie to detect a user’s first pageview session, which is a True/False flag set by the cookie.",
      },
      {
         cookieName: "__cf_bm",
         duration: "30 minutes",
         description:
            "This cookie is set by Hubspot whenever it changes the session cookie. The __hssrc cookie set to 1 indicates that the user has restarted the browser, and if the cookie does not exist, it is assumed to be a new session.",
      },
      {
         cookieName: "__hssc",
         duration: "30 minutes",
         description:
            "Cloudflare set the cookie to support Cloudflare Bot Management.",
      },
   ],
   analytics: [
      {
         cookieName: "_hjSessionUser_",
         duration: "1 year",
         description:
            "Hotjar sets this cookie to ensure data from subsequent visits to the same site is attributed to the same user ID, which persists in the Hotjar User ID, which is unique to that site.",
      },
      {
         cookieName: "_hjFirstSeen",
         duration: "30 minutes",
         description:
            "Hotjar sets this cookie to identify a new user’s first session. It stores the true/false value, indicating whether it was the first time Hotjar saw this user.",
      },
      {
         cookieName: "_hjSession_*",
         duration: "30 minutes",
         description:
            "Hotjar sets this cookie to ensure data from subsequent visits to the same site is attributed to the same user ID, which persists in the Hotjar User ID, which is unique to that site.",
      },
      {
         cookieName: "_fbp",
         duration: "3 months",
         description:
            "Facebook sets this cookie to display advertisements when either on Facebook or on a digital platform powered by Facebook advertising after visiting the website.",
      },
      {
         cookieName: "_gid",
         duration: "1 day",
         description:
            "Google Analytics sets this cookie to store information on how visitors use a website while also creating an analytics report of the website’s performance. Some of the collected data includes the number of visitors, their source, and the pages they visit anonymously.",
      },
      {
         cookieName: "_gat_gtag_UA_*",
         duration: "1 minute",
         description:
            "Google Analytics sets this cookie to store a unique user ID.",
      },
      {
         cookieName: "_ga_*",
         duration: "1 year 1 month 4 days",
         description:
            "Google Analytics sets this cookie to store and count page views.",
      },
      {
         cookieName: "_ga",
         duration: "1 year 1 month 4 days",
         description:
            "Google Analytics sets this cookie to calculate visitor, session and campaign data and track site usage for the site’s analytics report. The cookie stores information anonymously and assigns a randomly generated number to recognise unique visitors.",
      },
      {
         cookieName: "_hjRecordingLastActivity",
         duration: "never",
         description:
            "Hotjar sets this cookie when a user recording starts and when data is sent through the WebSocket.",
      },
      {
         cookieName: "__hstc",
         duration: "5 months 27 days",
         description:
            "Hubspot set this main cookie for tracking visitors. It contains the domain, initial timestamp (first visit), last timestamp (last visit), current timestamp (this visit), and session number (increments for each subsequent session).",
      },
      {
         cookieName: "hubspotutk",
         duration: "5 months 27 days",
         description:
            "HubSpot sets this cookie to keep track of the visitors to the website. This cookie is passed to HubSpot on form submission and used when deduplicating contacts.",
      },
   ],
   uncategorized: [
      {
         cookieName: "_hjIncludedInSessionSample_3470175",
         duration: "2 minutes",
         description: "Description is currently not available.",
      },
   ],
};
